import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3402';

export interface Comment {
  id: string;
  postId: string;
  authorId: string;
  content: string;
  parentId?: string;
  isDeleted: boolean;
  createdAt: string;
  updatedAt: string;
  author: {
    id: string;
    username: string;
    firstName?: string;
    lastName?: string;
    avatar?: string;
  };
  replies?: Comment[];
}

export interface CreateCommentPayload {
  content: string;
  parentId?: string;
}

export const commentsService = {
  async getComments(postId: string) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/posts/${postId}/comments`, {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    });
    return res.data as { comments: Comment[] };
  },

  async createComment(postId: string, payload: CreateCommentPayload) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.post(`${API_BASE_URL}/api/posts/${postId}/comments`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data as { comment: Comment };
  },

  async updateComment(postId: string, commentId: string, content: string) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.put(`${API_BASE_URL}/api/posts/${postId}/comments/${commentId}`, { content }, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data as { comment: Comment };
  },

  async deleteComment(postId: string, commentId: string) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.delete(`${API_BASE_URL}/api/posts/${postId}/comments/${commentId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data as { message: string };
  },
};


